import get from 'get-object-path';
import { FILTER_CUSTOM_ID } from '@/constants';

export const reportsRacing = {
    namespaced: true,

    state: {
        filterFields: {},
        filter: {
            name: '',
            boatTypes: [],
            distances: [],
            focuses: [],
            speedIntensities: [],
            hrIntensities: [],
            srIntensities: [],
            times: [],
            sport: null,
            rollingStart: FILTER_CUSTOM_ID
        },
        selected: {
            crews: [],
            sessions: [],
            pieces: []
        },
        highlighted: true,
        sessions: []
    },

    getters: {
        getFilter(state) {
            return state.filter;
        },

        getFilterFields(state) {
            return state.filterFields;
        },

        highlighted(state) {
            return state.highlighted;
        },

        selected(state) {
            return state.selected;
        },

        sessions(state) {
            return state.sessions;
        },

        sessionsCrews(state) {
            const crews = state.sessions
                .map(session =>
                    (get(session, 'parent_crews_on_event.data') || []).map(crew => ({
                        ...crew,
                        created_at: session.start_date
                    }))
                )
                .flat();
            const withoutParent = _.uniqBy(
                crews.filter(({ parent_id }) => !parent_id),
                'id'
            );
            const withParent = _.uniqBy(
                crews.filter(({ parent_id }) => parent_id),
                'parent_id'
            );
            return _.orderBy([...withoutParent, ...withParent], 'created_at', 'desc');
        }
    },

    mutations: {
        updateSport(state, sport) {
            state.filter.sport = sport;
        },

        manageItem(state, payload) {
            const list = state.selected[payload.list];
            const indexOf = list.indexOf(payload.id);

            if (payload.event) {
                indexOf === -1 && Vue.set(list, list.length, payload.id);
            } else {
                indexOf !== -1 && list.splice(indexOf, 1);
            }
        },

        setFilterFields(state, payload) {
            state.filterFields = payload;
        },

        setSessions(state, payload) {
            state.sessions.push(...payload);
        },

        toggleHighlight(state, payload) {
            state.highlighted = payload;
        },

        resetSessions(state) {
            state.sessions = [];
        },

        resetSelected(state) {
            state.selected = {
                crews: [],
                sessions: [],
                pieces: []
            };
        },

        resetFilter(state) {
            state.filter = {
                name: '',
                boatTypes: [],
                distances: [],
                focuses: [],
                speedIntensities: [],
                hrIntensities: [],
                srIntensities: [],
                times: [],
                sport: null,
                rollingStart: FILTER_CUSTOM_ID
            };
        },

        setSport(state, payload) {
            state.filter.sport = payload;
        },

        setBoatTypes(state, payload) {
            state.filter.boatTypes = payload;
        },

        setDistances(state, payload) {
            state.filter.distances = payload;
        },

        setTimes(state, payload) {
            state.filter.times = payload;
        },

        setSpeedIntensities(state, payload) {
            state.filter.speedIntensities = payload;
        },

        setHrIntensities(state, payload) {
            state.filter.hrIntensities = payload;
        },

        setSrIntensities(state, payload) {
            state.filter.srIntensities = payload;
        },

        setFocus(state, payload) {
            state.filter.focuses = payload;
        },

        setRollingStart(state, payload) {
            state.filter.rollingStart = payload;
        }
    },

    actions: {
        resetState(context) {
            context.commit('resetFilter');
            context.commit('resetSelected');
            context.commit('resetSessions');
            context.commit('setFilterFields', {});
            context.commit('toggleHighlight', true);
        },

        toggleCrews(context, payload) {
            context.commit('manageItem', { ...payload, list: 'crews' });
        },

        toggleSessions(context, payload) {
            context.commit('manageItem', { ...payload, list: 'sessions' });
        },

        togglePieces(context, payload) {
            context.commit('manageItem', { ...payload, list: 'pieces' });
        }
    }
};

export default reportsRacing;
